export default __webpack_public_path__ + "static/media/CastIronTableImg.97ff0ce4.jpg";